import service from "../service";

export default {
    async getCustomerInquire() {
        const response = await service.get(
            `/api/reservation/admin/get_all_reservation`
        );
        return response;
    },

    async updatedCompleteCustomerInquire(customerInquire) {
        const response = await service.patch(
            `/api/reservation/admin/update_reserve_state/to_complete`,
            customerInquire
        );
        return response;
    },

    async deleteCustomerInquire(customerInquire_id) {
        const response = await service.delete(
            `/api/reservation/remove_customer_reservation/${customerInquire_id}`
        );
        return response;
    },
};
